import axios from 'axios'
import { trackPromise } from 'react-promise-tracker';
import * as CommonVariables from '../../Common/CommonVariables'

// export const ValidateUser = async (userName, password) => {
//     //debugger;
//     var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/ValidateUser?emailId=${userName}&password=${password}`, CommonVariables.API_HEADER)).then(response => response);
//     return result;
// }

// export const ValidateUserOtp = async (userName, password, otp) => {
//     //debugger;
//     var result = await trackPromise(axios.get(CommonVariables.API_DOMAIN + `User/ValidateUserOtp?emailId=${userName}&password=${password}&otp=${otp}`, CommonVariables.API_HEADER)).then(response => response);
//     return result;
// }

export const ValidateUserPost = async (email, password) => {
    var result = await trackPromise(axios.post('https://dummyjson.com/auth/login', {
        username: email,
        password: password,
    }, CommonVariables.API_HEADER)).then(response => response);
    return result;
}


export const ValidateUser = async (data) => {
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `User/ValidateUser`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}
export const ValidateUserOtp = async (data) => {
    //debugger;
    var result = await trackPromise(axios.post(CommonVariables.API_DOMAIN + `User/ValidateUserOtp`, JSON.stringify(data), CommonVariables.API_HEADER)).then(response => response);
    return result;
}
